import React, {
  useReducer,
  useContext,
  useCallback,
  useState,
  useEffect,
} from "react";
import axios from "axios";

export const ShopContext = React.createContext();
const BASE_URL = "https://catway.services.ombre.app/v1/";

export const Shop = ({ children }) => {
  const [shopifyId, setShopifyId] = useState();

  useEffect(() => {
    getShopifyId();
  }, []);

  const getShopifyId = () => {
    var url =
      window.location != window.parent.location
        ? document.referrer
        : document.location.href;

    const trueUrl = new URL(url).host;

    return axios
      .get(BASE_URL + `os/shopify/domain?domain=${trueUrl}`)
      .then((res) => {
        setShopifyId(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <ShopContext.Provider value={{ shopifyId }}>
      {children}
    </ShopContext.Provider>
  );
};

export default Shop;
export const useShop = () => useContext(ShopContext);
